import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, Grid, TablePagination, TextField, Typography } from "@mui/material";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import Footer from "pages/LandingPages/Author/sections/Footer";
import MKBox from "components/MKBox";
import bgImage from "../../assets/images/city-profile.jpg"
import { useState } from "react";
import { useEffect } from "react";
import { get } from "utility/fetch";
import { numberWithCommas } from "utility/general";
import DatePicker from "react-flatpickr";
import { post } from "utility/fetch";
import EbanqoHelmet from "layouts/EbanqoHelmet";



export default function DownloadForms() {

    const [downloads, setDownloads] = useState([])


    const getDownloads = async () => {
        let res = await get(`/downloads`);
        console.log(res);
        setDownloads(res?.data?.data);
    }


    useEffect(() => {
        getDownloads()
    }, [])

    return (
        <div>
            <EbanqoHelmet />
            <DefaultNavbar
                routes={routes}
                action={{
                    type: "external",
                    route: "https://www.creative-tim.com/product/material-kit-react",
                    label: "free download",
                    color: "info",
                }}
                transparent
                light
            />
            <MKBox
                minHeight="10rem"
                width="100%"
                sx={{
                    backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.8),
                            rgba(gradients.dark.state, 0.8)
                        )}, url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "grid",
                    placeItems: "center",
                }}
            />



            <Typography sx={{ mt: 3 }} textAlign={"center"} variant="h4" >
                Download Forms
            </Typography>
            <Typography textAlign={"center"} variant="h5">
                All pension forms and documents.
            </Typography>



            <Grid container justifyContent={"center"} sx={{ mb: 5, mt: 5 }} spacing={2}>
                {Array?.isArray(downloads) && downloads.length > 1 &&
                    downloads?.map((item) => (
                        <Grid item sm={9} xs={9} md={5} lg={5} spacing={2}>
                            <Card>
                                <CardContent>
                                    <Typography textAlign={"start"} variant="h5" gutterBottom>{item.form}</Typography>
                                    <Typography textAlign={"start"} variant="body2"></Typography>

                                    <Box sx={{ mt: 2 }}>
                                        <a href={item.formUrl} target="_blank" download={item?.form}>Download</a>
                                    </Box>

                                </CardContent>
                            </Card>
                        </Grid>

                    ))}
            </Grid>








            <Footer />
        </div>
    );
}